export const FIELD_CLASS_NAMES = {
  labelClassName: 'nhs-c-input__label',
  fieldClassName: 'nhs-c-input__field',
  errorClassName: 'nhs-c-input__label--error',
};

export const SELECT_FIELD_CLASS_NAMES = {
  labelClassName: 'nhs-c-input__label',
  fieldClassName: 'nhs-c-input__select',
  errorClassName: 'nhs-c-input__label--error',
};
